<div class="item-container" [attr.data-column]="selectedPeriod()" [attr.data-asset]="productType.is_asset ? 'true' : 'false'">
  <button class="item item-block item-md button-shade item-button"
    [class.button-disabled]="!productType.is_asset"
    (click)="openAssetAvailability(productType)">
    <div class="item-inner">
      <div class="input-wrapper width-100">
        <div class="label label-md width-100">
          @if (productType.product_type_id !== -999) {
            <h2 class="ellipses-label item-heading"
            >{{productType.product_type_name}}</h2>
          }
          @if (productType.product_type_id === -999) {
            <h2 class="ellipses-label ellipses-label-all item-heading">
            {{labels.allProductsLabel}}</h2>
          }
          @if (productType.is_asset) {
            <p class="ellipses-sublabel">
              <span class="customer-text-count"
              [innerHTML]="getLabelTranslation('count_available', [productType.unit_count_current_available | number, productType.unit_count_current_in_fleet | number])"></span>&nbsp;
              @if (selectedCustomerCount() === 1) {
                <span
                  class="customer-text customer-text-green"
                  [innerHTML]="getLabelTranslation('Customer_has_count', [productType.customer_unit_count_current_rented])"
                ></span>
              }
              @if (selectedCustomerCount() > 1) {
                <span class="customer-text customer-text-green"
                  [innerHTML]="getLabelTranslation('Customers_have_count', [productType.customer_unit_count_current_rented])"
                ></span>
              }
            </p>
          }
          @if (productType?.unit_count_reserved) {
            <p class="ellipses-sublabel reserved-count"><i>{{ productType.unit_count_reserved }} {{ 'reserved' | translateLabel: [] }}</i></p>
          }
        </div>
        @if (productType.is_asset) {
          <app-item-arrow></app-item-arrow>
        }
      </div>
    </div>
  </button>
  @if (productType.product_type_id !== -999) {
    <div class="input-wrapper width-100">
      <div class="width-100 text-center">
        <table class="data-table">
          <tbody>
            <tr>
              <td>&nbsp;</td>
              <td class="cell-data" text-uppercase>
                <p class="column-title monthly">{{monthlyText}}</p>
              </td>
              <td class="cell-data" text-uppercase>
                <p class="column-title weekly" >{{weeklyText}}</p>
              </td>
              <td class="cell-data" text-uppercase>
                <p class="column-title daily">{{dailyText}}</p>
              </td>
              @if (showHourly) {
                <td class="cell-data" text-uppercase>
                  <p class="column-title hourly">{{hourlyText}}</p>
                </td>
              }
              @if (showHourly) {
                <td
                  class="cell-data-progress cell-data-progress-small column-title" rowspan="7">
                  <div class="progress-container-small progress-hourly">
                    <!-- The container is necessary to maintain table layout -->
                    @if (productType.is_asset) {
                      <app-progress-bar label="{{getLabelTranslation('Util')}}"
                        percent="{{productType.physical_utilization_current}}"
                        fillColor="{{getUtilFillColor(productType)}}"
                        class="test-util"
                        />
                    }
                    @if (productType.is_asset) {
                      <app-progress-bar showDetailsIfZero="false"
                        label="{{getLabelTranslation('Bench')}}"
                        percent="{{productType.physical_utilization_bench}}" fillColor="aqua"
                        class="test-bench"
                        />
                    }
                  </div>
                </td>
              }
              @if (!showHourly) {
                <td
                  class="cell-data-progress cell-data-progres column-title" rowspan="7">
                  <div class="progress-container progress-non-hourly">
                    <!-- The container is necessary to maintain table layout -->
                    @if (productType.is_asset) {
                      <app-progress-bar label="{{getLabelTranslation('Util')}}"
                        percent="{{productType.physical_utilization_current}}"
                        fillColor="{{getUtilFillColor(productType)}}"
                        class="test-util"
                        />
                    }
                    @if (productType.is_asset) {
                      <app-progress-bar showDetailsIfZero="false"
                        label="{{getLabelTranslation('Bench')}}"
                        percent="{{productType.physical_utilization_bench}}" fillColor="aqua"
                        class="test-bench"
                        />
                    }
                  </div>
                </td>
              }
            </tr>
            <tr>
              <td class="cell-label row1-label" text-uppercase>{{labels.row1Label}}</td>
              <td class="cell-data-bold row1-monthly">{{productType.monthly_rate_mobile_first_row |
              mqaCurrency: localeFormat}}</td>
              <td class="cell-data-bold row1-weekly">{{productType.weekly_rate_mobile_first_row | mqaCurrency:
              localeFormat}}</td>
              <td class="cell-data-bold row1-daily">{{productType.daily_rate_mobile_first_row | mqaCurrency:
              localeFormat}}</td>
              @if (showHourly) {
                <td class="cell-data-bold row1-hourly">
                  {{productType.hourly_rate_mobile_first_row | mqaCurrency:
                localeFormat}}</td>
              }
            </tr>
            @if (productType.show_mobile_second_row) {
              <tr>
                <td class="cell-label row2-label" text-uppercase>{{labels.row2Label}}</td>
                <td class="cell-data row2-monthly">{{productType.monthly_rate_mobile_second_row | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data row2-weekly">{{productType.weekly_rate_mobile_second_row | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data row2-daily">{{productType.daily_rate_mobile_second_row | mqaCurrency:
                localeFormat}}</td>
                @if (showHourly) {
                  <td class="cell-data row2-hourly">
                    {{productType.hourly_rate_mobile_second_row | mqaCurrency:
                  localeFormat}}</td>
                }
              </tr>
            }
            @if (productType.show_mobile_third_row) {
              <tr>
                <td class="cell-label row3-label" text-uppercase>{{labels.row3Label}}</td>
                <td class="cell-data row3-monthly">{{productType.monthly_rate_mobile_third_row | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data row2-weekly">{{productType.weekly_rate_mobile_third_row | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data row2-daily">{{productType.daily_rate_mobile_third_row | mqaCurrency:
                localeFormat}}</td>
                @if (showHourly) {
                  <td class="cell-data row2-hourly">
                    {{productType.hourly_rate_mobile_third_row | mqaCurrency:
                  localeFormat}}</td>
                }
              </tr>
            }
            @if (productType.show_mobile_fourth_row) {
              <tr>
                <td class="cell-label row4-label" text-uppercase>{{labels.row4Label}}</td>
                <td class="cell-data row4-monthly">{{productType.monthly_rate_mobile_fourth_row | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data row4-weekly">{{productType.weekly_rate_mobile_fourth_row | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data row4-daily">{{productType.daily_rate_mobile_fourth_row | mqaCurrency:
                localeFormat}}</td>
                @if (showHourly) {
                  <td class="cell-data row4-hourly">
                    {{productType.hourly_rate_mobile_fourth_row | mqaCurrency:
                  localeFormat}}</td>
                }
              </tr>
            }
            @if (productType.show_mobile_fifth_row) {
              <tr>
                <td class="cell-label row5-label" text-uppercase>{{labels.row5Label}}</td>
                <td class="cell-data row5-monthly">{{productType.monthly_rate_mobile_fifth_row | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data row5-weekly">{{productType.weekly_rate_mobile_fifth_row | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data row5-daily">{{productType.daily_rate_mobile_fifth_row | mqaCurrency:
                localeFormat}}</td>
                @if (showHourly) {
                  <td class="cell-data row5-hourly">
                    {{productType.hourly_rate_mobile_fifth_row | mqaCurrency:
                  localeFormat}}</td>
                }
              </tr>
            }
            @if (selectedCustomerCount() && labels.customerRowLabel !== '') {
              <tr>
                <td class="cell-label customer-label" text-uppercase>{{labels.customerRowLabel}}</td>
                <td class="cell-data customer-monthly">{{productType.customer_monthly_rate | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data customer-weekly">{{productType.customer_weekly_rate | mqaCurrency:
                localeFormat}}</td>
                <td class="cell-data customer-daily">{{productType.customer_daily_rate | mqaCurrency:
                localeFormat}}</td>
                @if (showHourly) {
                  <td class="cell-data customer-hourly">{{productType.customer_hourly_rate |
                  mqaCurrency: localeFormat}}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
  @if (productType.product_type_id !== -999 && showEstimate) {
    <ng-template [featureFlag]="'flagEnableCommissionEstimates'" >
      <aside [class.is-open]="isEstimateOpen()" [attr.data-min]="estimateMin()" [attr.data-max]="estimateMax()"
        class="drawer"
        [attr.aria-label]="translateService.instant('main.mobile.estimate_button')"
        >
        <div class="drawer-handle">
          <app-arrow-button
            [text]="translateService.instant('main.mobile.estimate_button')"
            [onClick]="toggleOpenEstimate"
            [isOpen]="isEstimateOpen()"
            [isLoading]="isEstimateLoading()"
            class="estimate-button"
            />
        </div>
        <div class="drawer-content"  [attr.aria-expanded]="isEstimateOpen()">
          <div class="drawer-content-left">
            @if (isEstimateLoaded()) {
              <div>
                <app-estimate-slider
                  [id]="productType.product_type_name"
                  [min]="estimateMin()"
                  [max]="estimateMax()"
                  [tiers]="tiersPercentages()"
                  [onChange]="onEstimateChange"
                  [colors]="estimateColors"
                  />
              </div>
            }
            <div class="rate-type">
              <span class="rate-type-label">{{labels.rateTypeLabel}}</span>
              <app-column-toggle name="metric" [options]="columnOptions" [value]="selectedPeriod()" [onChange]="onPeriodChange" />
            </div>
          </div>
          <div class="drawer-content-right">
            <app-estimate
              [estimate]="estimateComputedValue()"
              [min]="estimateMin()"
              [max]="estimateMax()"
              [metric]="metricLabel()"
              [percent]="estimatePercentage()"
              [localeFormat]="localeFormat"
              />
          </div>
        </div>
      </aside>
    </ng-template>
  }
</div>
